module.exports = __webpack_public_path__ + "img/zh4.988e95f9.png";